module.exports = __webpack_public_path__ + "static/media/corporate-services-img80.7f6ba9c8.jpg";